import { Select } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface CustomerSelectProps {
  value?: string;
  defaultQuery?: any;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  customer?: any;
  onChange?: (value: any) => void;
  onSelect?: (customer: any) => void;
}

const CustomerSelect: React.FC<CustomerSelectProps> = ({
  value,
  defaultQuery,
  showSearch,
  allowClear,
  disabled,
  onChange,
  onSelect,
}) => {
  const hasRun = useRef(false);
  const [state, updateState] = useState<any[]>([]);
  const onSearch = useCallback(
    async (query: string) => {
      try {
        let q = { ...defaultQuery, page: 1, size: 10, query };
        const { result } = await API.get({ apiVersion: 'api' })(
          `/customer/list?${new URLSearchParams(q).toString()}`
        );
        updateState(result?.data || []);
      } catch (error: any) {
        notifyError(error.message);
      }
    },
    [defaultQuery]
  );

  const loadFirst = useCallback(
    async (defaultQuery?: any) => {
      try {
        console.log('defaultQuery', defaultQuery);
        let query = { ...defaultQuery, page: 1, size: 10 };
        if (value) {
          query = { ...query, required: value };
        }
        let url = `/customer/list?${new URLSearchParams(query).toString()}`;
        const { result } = await API.get({ apiVersion: 'api' })(url);
        const list = result?.data || [];
        updateState(list);
      } catch (error: any) {
        notifyError(error.message);
      }
    },
    [value]
  );

  const changeHandler = useCallback(
    (value: string) => {
      const item = state.find((it: any) => it?.no + '' === value);
      if (onChange) onChange(value);
      if (onSelect) onSelect(item);
    },
    [state, onSelect, onChange]
  );

  useEffect(() => {
    if (value !== undefined && !hasRun.current) {
      loadFirst(defaultQuery);
      hasRun.current = true;
    }
  }, [value, loadFirst, defaultQuery]);

  useEffect(() => {
    loadFirst(defaultQuery);
  }, []);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no + '',
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Харилцагч сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      onSearch={(query: string) => onSearch(query)}
      onChange={changeHandler}
      options={options}
      disabled={disabled}
      value={value}
      filterOption={false}
    />
  );
};

export default CustomerSelect;
